module.exports = __webpack_public_path__ + "static/media/4.dc237347.jpeg";